import {
    FieldInCard,
} from 'app/types/form.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LoggerFormData,
    LoggerValue,
} from './LoggerForm.types'

type LoggerFormField = FieldInCard<keyof LoggerFormData>

const fields = ({
    loadOptions,
    loadLabel,
    value: {
        positionConfiguration,
    },
    loggerLabels,
}: {
    loadOptions: any,
    loadLabel: any,
    value: LoggerValue,
    loggerLabels: any,
}): LoggerFormField[] => {
    const allowedLoggerPositionValues = positionConfiguration
        ? positionConfiguration.reduce((acc, name) => {
            return {
                ...acc,
                [name]: loggerLabels[name] || name,
            }
        }, {}) : {}

    return [{
        id: 'logger',
        fields: [
            {
                label: 'Logger',
                componentName: 'TypeaheadObjectContainer',
                labelKey: 'LoggerInformationDto.logger',
                name: 'logger',
                className: 'internalLogger',
                loadLabel,
                loadOptions,
                labelField: 'loggerNumber',
                required: true,
            },
            {
                name: 'isDefaultLogger',
                className: 'isDefaultLogger',
                labelKey: 'LoggerInformationDto.defaultLogger',
                componentName: 'Checkbox',
            },
            {
                name: 'exchangeDocumentations',
                labelKey: 'LoggerInformationDto.exchangeDocumentations',
                className: 'exchangeDocumentations',
                componentName: 'AttachmentsObjectSelector',
            },
            {
                name: 'exchangeTimestamp',
                className: 'exchangeTimestamp',
                componentName: 'DateTimeZonedSelect',
                required: true,
            },
            {
                name: 'removedOn',
                componentName: 'DateTimeZonedSelect',
                labelKey: 'LoggerContainerInformation.removedOn',
            },
            {
                name: 'loggerPositionConfiguration',
                required: true,
                useDropdown: true,
                componentName: 'EnumSelector',
                allowedValues: allowedLoggerPositionValues,
                labelKey: 'LoggerInformationDto.loggerPositionConfigurationName',
            },
            {
                name: 'exchangeComment',
                className: 'exchangeComment',
                componentName: 'LongText',
                rows: 5,
            },
            {
                name: 'linkToCreate',
                componentName: 'SkyNetLink',
                link: '/apps/loggers/all/create',
                text: 'Logger Missing? Add Here',
                type: TypeLink.INTERNAL_WITH_ICON,
                size: SizeLink.S,
            },
        ],
    }]
}

export default fields
